module.exports = __webpack_public_path__ + "img/cb1efcf9ecae489a919042203f54558b.15a28531.jpg";